import React from 'react'
import {Icon} from '@chakra-ui/react'

const CarouselNextIcon = (props) => (
    <Icon viewBox="0 0 16 16" boxSize="16px" fill="none" {...props}>
        <path
            d="M6.5 12L10.5 8L6.5 4"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
)

export default CarouselNextIcon
